import React from 'react';

import Tooltip from '@/components/Tooltip';

import { Text } from './styles';

interface Props {
  title: string;
  maxWidth?: number;
}

const TooltipOverflow: React.FC<Props> = ({ title, maxWidth = 300 }) => {
  const textRef = React.useRef<HTMLSpanElement>(null);

  const isTruncated = React.useCallback(() => {
    const element = textRef.current;

    if (!element) {
      return false;
    }

    return element.scrollWidth > element.clientWidth;
  }, []);

  return (
    <Tooltip
      title={title}
      onShow={() => {
        if (!isTruncated()) {
          return false;
        }

        return undefined;
      }}
    >
      <Text ref={textRef} style={{ maxWidth }}>
        {title}
      </Text>
    </Tooltip>
  );
};

export default TooltipOverflow;
